import { render, staticRenderFns } from "./AllSpacesTable.vue?vue&type=template&id=11ee6ef9&scoped=true&"
import script from "./AllSpacesTable.vue?vue&type=script&lang=js&"
export * from "./AllSpacesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllSpacesTable.vue?vue&type=style&index=0&id=11ee6ef9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee6ef9",
  null
  
)

export default component.exports